import tools from "tools";
import videojs from "video.js";
import initHls from "hlsjs_videojs_source_handler";
import "vjs_flash";
import oldVjs from "combo_gagnant";
import { close } from "eb_driver";
import "videojs-flash";

import * as contribAds from "videojs-contrib-ads";

import loadPlugins from "./loadPlugins.js";
import { XDomainRequest } from "xhr";
// import "brightcove/videojs-flashls-source-handler";
const ima = require("videojs-ima");
// require("videojs-flashls-source-handler");

let vjs;
let el;
let options;

async function initPlayer(opts) {
  options = opts;
  el = tools.createVideoElement(options);
  
  if (options.oldVjs) {
    // console.log('I am in oldvjs which returns error');
    return oldVjs(options);
  }
  if (options.newTech === "contrib-hls") {
    // eslint-disable-next-line
    window.videojs = videojs;
    await tools.loadFile(
      "https://unpkg.com/videojs-flash/dist/videojs-flash.js",
      // "https://unpkg.com/videojs-contrib-hls/dist/videojs-contrib-hls.js",
      "script",
      "head",
    );
    // techOrder = "flash";
    await tools.loadFile(
      "https://unpkg.com/videojs-contrib-hls/dist/videojs-contrib-hls.js",
      "script",
      "head",
    );
    options.tech = "contrib-hls";
  }
  
  if (options.tech === "hlsjs") initHls();

  const vjs = videojs(options.playerID, {
      Html5: {
        el,
        nativeTextTracks: true,
      },
      flash: {
        swf: "https://unpkg.com/@brightcove/videojs-flashls-source-handler/dist/video-js.swf",
        hls: {
          nativeTextTracks: false,
          withCredentials: true,
        },
      },
      textTrackSettings: true,
      safari: true,
      preload: false,
      controls: true,
      nativeControlsForTouch: false,
      enableLowInitialPlaylist: false,
      ...options,
      plugins: {},
  }
  );

  
  vjs.one("loadEB", () => {
    vjs.easybroadcast({ ...options.EBLib, url: options.src });
  });

  const startPlayer = () => {
    // videojs.Hls.xhr = new XDomainRequest();
    // console.log("StartPlayer")
    console.log("options.src",options.src)
    if (!options.plugins.videojs_playlist) {
      vjs.src({
        src: options.src,
        type: options.type,
        withCredentials: true,
      });
      vjs.play();
      // return false;
    }
    // vjs.play();
    vjs.plugins = options.plugins;

    loadPlugins(options.plugins, vjs, options.browsers, {
      EBLib: options.EBLib,
      playerID: options.playerID,
    });
    if (options.autoplay) vjs.play();

    vjs.ready(() => {
      if (options.EBLib) {
        vjs.trigger("loadEB");
      }
    });
  };

  if (options.plugins.videojs_vast) {
    tools.loadFileWait(
      "https://imasdk.googleapis.com/js/sdkloader/ima3.js",
      err => {
        if (err) {
          startPlayer();
          return false;
        }
        videojs.deregisterPlugin("ads");
        videojs.registerPlugin("ads", contribAds.default);
        videojs.registerPlugin(ima.name, ima.init);
        vjs.ima({
          id: options.playerID,
          adTagUrl: options.plugins.videojs_vast.adTagUrl,
        });
        vjs.ima.initializeAdDisplayContainer();
        startPlayer();
        tools.addCSS(
          `${options.playerID}-ad-overlay`,
          options.plugins.videojs_vast.css_overlay,
        );
        let adClose;
        const checkAd = () => {
          setInterval(() => {
            if (vjs.ads.isInAdMode()) {
              if (vjs.ads.adType === "preroll") {
                const elements = document.getElementsByClassName(
                  `vjs-style-${options.playerID}-ad-overlay`,
                );
                while (elements.length > 0) {
                  elements[0].parentNode.removeChild(elements[0]);
                }
                clearInterval(checkAd);
              } else if (!adClose) {
                adClose = setTimeout(() => {
                  if (vjs.ads.adType !== "preroll") {
                    tools.addCSS(
                      `${options.playerID}-ad-close-overlay`,
                      options.plugins.videojs_vast.css_close_overlay,
                    );
                    document.getElementsByClassName(
                      "ima-close-ad",
                    )[0].onclick = () => {
                      const elements = document.getElementsByClassName(
                        `${options.playerID}_ima-ad-container`,
                      );
                      while (elements.length > 0) {
                        elements[0].parentNode.removeChild(elements[0]);
                      }
                    };
                    clearInterval(checkAd);
                  }
                }, 1000);
              }
            }
            setTimeout(() => {
              clearInterval(checkAd);
            }, 30000);
          }, 200);
        };
        vjs.one("play", () => checkAd());
        return true;
      },
    );
  } else startPlayer();
}

const closePlayer = () => {
  close(vjs);
  const parent = el.parentNode.parentNode;
  vjs.dispose();

  const newNode = document.createElement("video");
  newNode.setAttribute("id", options.playerID);
  parent.appendChild(newNode);
};

export { initPlayer, closePlayer };



// WEBPACK FOOTER //
// ./src/js/initPlayer.js